import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstrumentChartCarouselComponent } from './instrument-chart-carousel.component';
import { InstrumentChartCardComponent } from '../instrument-chart-card/instrument-chart-card.component';
import { InstrumentChartDropdownModule } from '../instrument-chart-card/instrument-chart-dropdown/instrument-chart-dropdown.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { BaseChartDirective } from 'ng2-charts';
import { TooltipButtonModule } from '../../tooltip-button/tooltip-button.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { RegionChartCardComponent } from '../region-chart-card/region-chart-card.component';
import { HistoryChartCardComponent } from '../history-chart-card/history-chart-card.component';
import { PreloadSpinnerModule } from '../../preload-spinner/preload-spinner.module';

@NgModule({
    declarations: [
        InstrumentChartCardComponent,
        InstrumentChartCarouselComponent,
        RegionChartCardComponent,
        HistoryChartCardComponent,
    ],
    exports: [
        InstrumentChartCarouselComponent,
    ],
    providers: [
        TranslatePipe,
    ],
    imports: [
        CommonModule,
        InstrumentChartDropdownModule,
        BaseChartDirective,
        TranslateModule,
        TooltipButtonModule,
        AngularSvgIconModule,
        PreloadSpinnerModule
    ]
})
export class InstrumentChartCarouselModule { }
